export enum AuthenticationType2FA {
	OTP = 'OTP',
	FACE_MATCH = 'FACE_MATCH',
	TWO_FACTOR_AUTHENTICATION = 'TWO_FACTOR_AUTHENTICATION',
}

export enum OtpResentMethods {
	USSD_MODE = 'USSD_MODE',
	SMS  = 'SMS',
	WHATSAPP = 'WHATSAPP'
}
